module.exports = __webpack_public_path__ + "img/coors-light-landing-bg.d83d1d69.jpg";